<template>
  <div style="position: relative;">
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-model='theSelectProjectId' v-if="theUserProject==0" clearable size="small"
          @change="theSelectProjectChange" placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data||[]" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="theUserProject==0 ? 6 :null">
        <el-button xv-if="addSysRulePoints " @click="toAddSysRulePoints" size='small' type="primary" style="float:right"
          icon='el-icon-circle-plus'>添加团队积分规则
        </el-button>
      </el-col>
    </el-row>
    <mytable :tableColums='tableColums_getSysRulePointsDtList' api='getSysRulePointsDtList'
      xupdateapi='updateSysRulePoints' :height="H-165">
    </mytable>

    <div style="width: 100%; height: 100%; background-color: white; position: absolute;top: 0;left: 0;z-index:666;"
      v-if="formshow == 1">
      <el-row style="text-align: right;margin: 15px;">
        <el-button type="danger" icon="el-icon-error" circle @click="formclose()"></el-button>
      </el-row>
      <h2 style="width: 100%;text-align: center;color: red;">新增团队规则</h2>
      <div style="width: 70%;margin: 50px auto;padding: 50px;">
        <el-form :model="Myformdata" size="medium" ref="formdata" :rules="rules">

          <el-row style="width: 80%; margin: 20px auto;">
            <el-form-item label="项目" prop="projectId" v-if="theUserProject==0">
                <el-select v-model='Myformdata.projectId' v-if="theUserProject==0" clearable size="small" placeholder="请选择项目" @change="projectChange">
                  <el-option v-for="item in getProjectList_data.data||[]" :key="item.projectId" :label="item.projectName"
                    :value="item.projectId">
                  </el-option>
                </el-select>
            </el-form-item>
          </el-row>

          <el-row style="width: 80%; margin: 20px auto;">
            <el-form-item label="战队" prop="dtId">
                <el-cascader ref='cascader2' v-model="Myformdata.dtId" clearable filterable xsize='medium' placeholder='请选择战队'
                  :show-all-levels='false' :options="getDepartmentAllList_data ? getDepartmentAllList_data.data : []"
                  :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'dtName', value: 'dtId', children: 'children' }"
                  @change="$refs.cascader2.dropDownVisible=false">
                  <template slot-scope="{ data }">
                    <span onclick="this.parentNode.previousElementSibling.click()">{{ data.dtName }}</span>
                  </template>
                </el-cascader>
            </el-form-item>
          </el-row>

          <el-row style="width: 80%; margin: 20px auto;">
            <el-form-item label="倍数" prop="srpdMultiply">
              <el-input v-model.number="Myformdata.srpdMultiply" type="number" size="small" placeholder="请输入倍数"></el-input>
            </el-form-item>
          </el-row>

          <el-row style="width: 60%; margin: 20px auto;padding-left: 100px;">

          <el-button type="success" round @click="sub()" size="medium" style="width: 200px;">提交</el-button>
          </el-row>
        </el-form>
      </div>
      </div>

      <div style="width: 100%; height: 100%; background-color: white; position: absolute;top: 0;left: 0;z-index:555;" v-if="formshow2 == 1">
      <el-row style="text-align: right;margin: 15px;">
        <el-button type="danger" icon="el-icon-error" circle @click="formclose()"></el-button>
      </el-row>
      <h2 style="width: 100%;text-align: center;color: red;">编辑团队规则</h2>
      <div style="width: 70%;margin: 50px auto;padding: 50px;">
        <el-row style="width: 100%; text-align: center; margin: 20px auto;">
             <h3 style="width: 100%;text-align: center;margin: 15px 0; color: deepskyblue;">倍数</h3>
            <el-input v-model.number="srpdMultiply2" type="number" size="small" placeholder="请输入倍数" style="height: 80px; width: 200px; font-size: 1.2rem;line-height: 80px;"></el-input>

        </el-row>
        <el-row style="width: 100%; text-align: center; margin: 20px auto;">

        <el-button type="success" round @click="updatasuccess()" size="medium" style="width: 200px;">提交</el-button>
        </el-row>
      </div>
       </div>

    </div>
</template>

<script>
  export default {
    data() {
      return {
        srpdId:null,
        formshow2 :"2",
        srpdMultiply2:null,
        project:null,
        rules:{
          projectId:[
             { required: true, message: '请选择项目', trigger: 'change' }
          ],
          dtId:[
            { required: true, message: '请选择战队', trigger: 'change' }
          ],
          srpdMultiply:[
             { required: true, message: '请输入倍数', trigger: 'blur' }
          ],

        },
        Myformdata:{
          projectId:null,
          dtId:null,
          srpdMultiply:null,
        },
       formshow :"2",
       theUserProject: "",
       theSelectProjectId: "",
       tableColums_getSysRulePointsDtList: {
          $selection: false,

          projectName: '项目',

            dtName: '分公司',

          srpdMultiply: '倍数',

          srpdMultiplyReal: '实际倍数',

          sprdTimeReal: '翻倍时间',

          srpdStatus: ['状态', , '@v-if: 1:未完成#danger, 2:完成#success'],

          createtime: '创建时间',


          $operation: [
            '操作', 200,
            this.updateSysRulePoints && `@text: 编辑#success
             @click: updatarule($row)
            `,
            this.deleteSysRulePoints && `@text: 删除#danger
             @click: _confirm('确定要删除该积分规则吗?')
                     .trigger('deleteSysRulePointsDt',{srpdId:$row.srpdId})
                     .trigger('getSysRulePointsDtList')

            `,
          ],
        },
      }
    },
    methods: {
     async updatasuccess(){
            this.updateSysRulePointsDt({
            srpdId:this.srpdId,
            srpdMultiply:this.srpdMultiply2,
            },'正在更新').result(res=>{
                if(!res) return;
                alertSuccess('更新成功!');
                  this.getSysRulePointsDtList({
                    projectId: this.theSelectProjectId
                });
                this.formshow2=2
             })
      },
      updatarule(e){
        this.formshow2 = 1;
        this.srpdId = e.srpdId
        this.srpdMultiply2 = e.srpdMultiply
        console.log(e)
      },
      async sub(){
        console.log(this.Myformdata)
        this.addSysRulePointsDt(this.Myformdata,'正在提交').
        result(res=>{
          if(!res) return;
          alertSuccess('提交成功!');
            this.Myformdata={
              projectId:null,
              dtId:null,
              srpdMultiply:null,
            }
            this.formshow=2
            this.project=null
            this.getSysRulePointsDtList({
              projectId: this.theSelectProjectId
            });
        });
      },
      async projectChange(e){
        console.log(e)
        this.project = e
        this.getDepartmentAllList({projectId:this.project})
      },
      formclose(){
        this.formshow=2
        this.formshow2=2
        this.Myformdata={
         projectId:null,
         dtId:null,
         srpdMultiply:null,
       }
       this.getSysRulePointsDtList({
         projectId: this.theSelectProjectId
       });
    },
      toAddSysRulePoints() {
        this.formshow = 1;

      },
      theSelectProjectChange(e) {
        //搜索
        this.theSelectProjectId = e;
        this.getSysRulePointsDtList({
          projectId: this.theSelectProjectId
        });
        this.getProjectBusiness({
          projectId: e
        })
      },

    },
    created() {
      this.theUserProject = A.local('$projectId');
      if (this.theUserProject != 0) {
        this.theSelectProjectId = this.theUserProject;
        this.getProjectBusiness({
          projectId: this.theSelectProjectId
        });
      }
      this.getSysRulePointsDtList({
        projectId: this.theSelectProjectId
      });
      this.getProjectList({pageSize: 0});
      this.getDepartmentAllList({projectId:this.theSelectProjectId});
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/rule/TeamPoints.vue